import {
  borderWidths,
  colors,
  layers,
  media,
  spacing,
} from '@lamimed/pantheon';
import { math } from 'polished';
import styled, { css } from 'styled-components';

import { tabbarHeight } from 'components/Tabbar/styles';

import { navigationHeight } from '../Navigation/styles';

export const mobileWrapperHeaderHeight = '6rem';
export const tabletWrapperHeaderHeight = '6.6rem';

const headerSizeWithHeaderAndTabBar = (
  haveTabbar: ContainerProps['haveTabbar'],
  wrapperHeaderHeight: string,
) => {
  if (haveTabbar) {
    return math(`${wrapperHeaderHeight} + ${tabbarHeight}`);
  }

  return wrapperHeaderHeight;
};

type ContainerProps = {
  haveTabbar: boolean;
};

export const Container = styled.div<ContainerProps>`
  ${({ haveTabbar }) => css`
    width: 100%;
    height: ${headerSizeWithHeaderAndTabBar(
      haveTabbar,
      mobileWrapperHeaderHeight,
    )};
    position: fixed;
    top: ${navigationHeight};
    grid-area: header;
    border-bottom: ${borderWidths.thin} solid ${colors.neutral_light};
    padding: ${spacing.medium} ${spacing.medium}
      ${haveTabbar ? spacing.none : spacing.small} ${spacing.medium};
    background-color: ${colors.light};
    z-index: ${layers.menu};

    ${media.greaterThan('tablet')`
      height: ${headerSizeWithHeaderAndTabBar(
        haveTabbar,
        tabletWrapperHeaderHeight,
      )};

      ${media.greaterThan('desktop')`
        height: initial;
        position: initial;
        z-index: initial;
      `};
    `};
  `};
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
